import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {ImageProps} from 'app/utilities/ImageProps';
import EpiContext from '@episerver/spa-core/Spa';

type ProductDescriptionImageBlockProps = {
  image: ImageProps;
  link: string;
  linkTitle: string;
  isFloatingButton: boolean;
};

const func = (link: any) => {
  if (link !== null && link!="")
  EpiContext.navigateTo(link);
};

const ProductDescriptionImageBlock = ({image, link, linkTitle, isFloatingButton}: ProductDescriptionImageBlockProps) => {

  return (

    <div className='ProductDescriptionImageBlock'>
      {link !== null && link!="" ? (
       <Image className='ProductDescriptionImageBlock__imageCursor'
        {...image}
        onClick={() => {
          func(link);
        }} />


    ) : (
      <>
         <Image className='ProductDescriptionImageBlock__image'
        {...image} />
    </>
    )}

      {link && link!="" &&(
        <div className={`ProductDescriptionImageBlock__link ${isFloatingButton ? 'isFloatingButton' : ''}`}>
          <a href={link}>{linkTitle}</a>
        </div>
      )}
    </div>
  );
};

export default ProductDescriptionImageBlock;
